import { calculateViewportUnits, calculateHeaderSize } from "../functions/window";

let resizeTimer = false;
let lastWindowWidth = window.innerWidth;

calculateViewportUnits();
calculateHeaderSize();

window.addEventListener("resize", (event) => {
    clearTimeout(resizeTimer);

    resizeTimer = setTimeout(function () {
        calculateViewportUnits();
        calculateHeaderSize();

        if (window.innerWidth === lastWindowWidth) {
            return;
        }

        lastWindowWidth = window.innerWidth;

        window.rEvent.dispatch("Window.resized");
    }, 250);
});
